<template>
  <!--报名表内容-->
  <div class="formBox__content">
    <!--报名表表单-->
    <el-form class="registrationForm">
      <!--分会议选择器-->
      <el-row :gutter="20" class="hideInDialog">
        <el-col :span="4"><div style="padding: 10px 0"></div></el-col>
        <el-col :span="16">
          <div style="padding: 10px 0"></div>
          <!-- 报名状态
                    <el-form-item label="报名状态:" :label-width="formLabelWidth">
                        <span v-if="this.registration_status === 1">已报名</span>
                        <span v-else>未报名</span>
                    </el-form-item>
                    -->
        </el-col>
        <el-col :span="4" style="text-align: right">
          <el-button style="display: none" @click="reviewDialogVisible = true"
            >审核详情</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <!-- --------------------报名信息折叠面板-------------------- -->
        <div class="SH_card">
          <el-form
            :model="registration_info_item"
            ref="registration_info_item"
            :rules="formRegistrationRule"
          >
            <div class="SH_card-title">
              <span style="font-size: 14px">报名信息</span>
              <div
                style="text-align: right"
                v-if="this.registrationInfoEditDisable !== false"
              >
                <el-button
                  type="primary"
                  size="small"
                  @click="editRegistrationInfo"
                  >编辑</el-button
                >
              </div>
              <div style="text-align: right" v-else>
                <el-button
                  type="primary"
                  size="small"
                  @click="handleSubmit(true)"
                  >保存</el-button
                >
              </div>
            </div>
            <div class="SH_card-body">
              <el-divider></el-divider>
              <el-row :gutter="30" v-if="has_sub_forum">
                <el-col :span="18">
                  <el-row :gutter="30">
                    <el-col :span="22">
                      <!--分会议选择器-->
                      <el-form-item
                        label="分会议:"
                        size="small"
                        :label-width="formLabelWidth"
                      >
                        <el-select
                          :disabled="registrationInfoEditDisable"
                          v-model="registration_info_item.sub_forum_id"
                          placeholder="未选择分会议"
                        >
                          <el-option :value="null" label="无"></el-option>
                          <el-option
                            v-for="item in subEvents"
                            :key="item.sub_forum_id"
                            :label="item.name"
                            :value="item.sub_forum_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="9"></el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="12">
                  <el-form-item
                    prop="name"
                    label="姓名:"
                    :label-width="formLabelWidth"
                  >
                    <div
                      style="text-align: left"
                      v-if="this.registrationInfoEditDisable === true"
                    >
                      {{ registration_info_item.name }}
                    </div>
                    <el-input
                      v-else
                      v-model="registration_info_item.name"
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    prop="formRegistrationInfo.gender"
                    label="性别:"
                    :label-width="formLabelWidth"
                  >
                    <div
                      style="text-align: left"
                      v-if="this.registrationInfoEditDisable === true"
                    >
                      <span
                        v-if="
                          this.registration_info_item.formRegistrationInfo
                            .gender !== ''
                        "
                      >
                        <span
                          v-for="(item, index) in gender_type_list.items"
                          :key="index"
                        >
                          <span
                            v-if="
                              item.value ===
                              registration_info_item.formRegistrationInfo.gender
                            "
                          >
                            {{ item.name }}
                          </span>
                        </span>
                      </span>
                      <span v-else>N/A</span>
                    </div>
                    <el-radio-group
                      v-else
                      :disabled="registrationInfoEditDisable"
                      v-model="
                        registration_info_item.formRegistrationInfo.gender
                      "
                    >
                      <el-radio
                        v-for="item in gender_type_list.items"
                        :key="item.value"
                        :label="item.value"
                        >{{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="9" :xs="24">
                  <el-form-item
                    prop="organization"
                    label="单位:"
                    :label-width="formLabelWidth"
                  >
                    <div
                      style="text-align: left"
                      v-if="this.registrationInfoEditDisable === true"
                    >
                      {{ registration_info_item.organization }}
                    </div>
                    <el-input
                      v-else
                      v-model="registration_info_item.organization"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="9" :xs="24">
                  <el-form-item
                    prop="formRegistrationInfo.cell_phone"
                    label="手机:"
                    :label-width="formLabelWidth"
                  >
                    <div
                      style="text-align: left"
                      v-if="this.registrationInfoEditDisable === true"
                    >
                      {{
                        registration_info_item.formRegistrationInfo.cell_phone
                      }}
                    </div>
                    <el-input
                      v-else
                      v-model="
                        registration_info_item.formRegistrationInfo.cell_phone
                      "
                      size="small"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15"> </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="SH_card">
          <el-form>
            <div class="SH_card-title">
              <span style="font-size: 14px">缴费信息</span>
            </div>
            <div class="SH_card-body">
              <el-divider />
              <el-row :gutter="30">
                <el-col :span="12" :xs="24">
                  <el-form-item label="注册类型:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ currentRegisterType.name }}
                    </div>
                    <el-select
                      size="small"
                      v-model="registration_info_item.registration_level"
                      v-else
                    >
                      <el-option
                        v-for="item in registerTypes"
                        :key="item.key"
                        :value="item.key"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <template
                  v-if="registration_info_item.registration_level == null"
                  ><el-col :span="12" :xs="24">
                    <el-form-item
                      label="缴费金额:"
                      :label-width="formLabelWidth"
                    >
                      <div style="text-align: left">请选择注册类型</div>
                    </el-form-item>
                  </el-col></template
                >
                <template v-else-if="currentRegisterType.fee">
                  <el-col :span="12" :xs="24">
                    <el-form-item
                      label="缴费金额:"
                      :label-width="formLabelWidth"
                    >
                      <div style="text-align: left">
                        {{ currentRegisterType.fee }}
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :xs="24">
                    <el-form-item
                      label="缴费二维码:"
                      :label-width="formLabelWidth"
                    >
                      <img
                        style="height: 200px"
                        :src="`/forum-pub-api/v1/minio/getFile?file_url=${currentRegisterType.qrcode}`"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :xs="24">
                    <el-form-item
                      label="缴费成功截图:"
                      :label-width="formLabelWidth"
                    >
                      <img
                        v-if="registrationInfoEditDisable"
                        :src="
                          '/forum-pub-api/v1/minio/getFile?file_url=' +
                          registration_info_item.paymentInfo
                            .payment_result_screenshot
                        "
                        class="avatar"
                      />
                      <el-upload
                        v-else
                        class="avatar-uploader"
                        action="/forum-pub-api/v1/file/upload"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        name="file_name"
                      >
                        <img
                          v-if="
                            registration_info_item.paymentInfo
                              .payment_result_screenshot
                          "
                          :key="
                            registration_info_item.paymentInfo
                              .payment_result_screenshot
                          "
                          :src="
                            '/forum-pub-api/v1/minio/getFile?file_url=' +
                            registration_info_item.paymentInfo
                              .payment_result_screenshot
                          "
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item> </el-col
                ></template>
                <template v-else
                  ><el-col :span="12" :xs="24">
                    <el-form-item
                      label="缴费金额:"
                      :label-width="formLabelWidth"
                    >
                      <span>无需缴费</span>
                    </el-form-item>
                  </el-col></template
                >
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="SH_card">
          <el-form>
            <div class="SH_card-title">
              <span style="font-size: 14px">开票信息</span>
            </div>
            <div class="SH_card-body">
              <el-divider />
              <el-row :gutter="30">
                <el-col :span="12" :xs="24">
                  <el-form-item label="名称:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.name }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.name"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item
                    label="纳税人识别号:"
                    :label-width="formLabelWidth"
                  >
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.code }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.code"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="地址:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.address }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.address"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="电话:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.phone }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.phone"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="开户行:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.bank }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.bank"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="账号:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.account }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.account"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="邮寄地址:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.mail_address }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.mail_address"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="电子邮箱:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.email }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.email"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="备注:" :label-width="formLabelWidth">
                    <div
                      v-if="registrationInfoEditDisable"
                      style="text-align: left"
                    >
                      {{ registration_info_item.invoiceInfo.comment }}
                    </div>
                    <el-input
                      v-else
                      size="small"
                      v-model="registration_info_item.invoiceInfo.comment"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <!--代办住宿折叠面板-->
        <div class="SH_card">
          <el-form
            :model="registration_info_item.formHotelInfo"
            ref="formHotelInfo"
          >
            <div class="SH_card-title">
              <span style="font-size: 14px">住宿信息</span>
              <!-- <div
                style="text-align: right"
                v-if="this.registrationInfoEditDisable !== false"
              >
                <el-button
                  type="primary"
                  size="small"
                  @click="editRegistrationInfo"
                  >编辑</el-button
                >
              </div>
              <div style="text-align: right" v-else>
                <el-button
                  type="primary"
                  size="small"
                  @click="saveRegistrationInfo('registration_info_item')"
                  >保存</el-button
                >
              </div> -->
            </div>
            <div class="SH_card-body">
              <el-divider></el-divider>
              <el-row :gutter="30">
                <el-col :span="12" :xs="24">
                  <el-form-item label="酒店名称:" :label-width="formLabelWidth">
                    <el-select
                      :disabled="registrationInfoEditDisable"
                      v-model="registration_info_item.formHotelInfo.hotel_name"
                      placeholder="酒店名称"
                      size="small"
                    >
                      <el-option
                        v-for="item in hotels"
                        :key="item.hotel_name"
                        :label="item.hotel_name"
                        :value="item.hotel_name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item label="房型:" :label-width="formLabelWidth">
                    <el-select
                      :disabled="registrationInfoEditDisable"
                      v-model="
                        registration_info_item.formHotelInfo.hotel_room_type
                      "
                      placeholder="房型"
                      size="small"
                    >
                      <el-option
                        v-for="item in currentHotel.hotel_room_types"
                        :key="item.room_type"
                        :label="item.room_type"
                        :value="item.room_type"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :xs="24">
                  <el-form-item
                    label="房间数量:"
                    :label-width="formLabelWidth"
                    style="text-align: left"
                  >
                    <div
                      style="text-align: left"
                      v-if="registrationInfoEditDisable"
                    >
                      {{ registration_info_item.formHotelInfo.number_of_room }}
                    </div>
                    <el-input-number
                      v-else
                      size="small"
                      controls-position="right"
                      v-model="
                        registration_info_item.formHotelInfo.number_of_room
                      "
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="SH_card" v-if="!!extraFields.length">
          <el-form>
            <div class="SH_card-title">
              <span style="font-size: 14px">其他要求附件</span>
            </div>
            <div class="SH_card-body">
              <el-divider />
              <el-row :gutter="30">
                <el-col
                  :span="12"
                  :xs="24"
                  v-for="item in extraFields"
                  :key="item.key"
                >
                  <el-form-item
                    :label="item.name"
                    :label-width="formLabelWidth"
                  >
                    <template v-if="item.type === 'text'"
                      ><div
                        v-if="registrationInfoEditDisable"
                        style="text-align: left"
                      >
                        {{ registration_info_item.extraInfo[item.key].value }}
                      </div>
                      <el-input
                        v-else
                        v-model="
                          registration_info_item.extraInfo[item.key].value
                        "
                        size="small"
                    /></template>
                    <template v-if="item.type === 'image'"
                      ><div
                        v-if="registrationInfoEditDisable"
                        style="text-align: left"
                      >
                        <img
                          :src="
                            '/forum-pub-api/v1/minio/getFile?file_url=' +
                            registration_info_item.extraInfo[item.key].value
                          "
                          class="avatar"
                        />
                      </div>
                      <UploadImage
                        v-else
                        v-model="
                          registration_info_item.extraInfo[item.key].value
                        "
                    /></template>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
        <div class="SH_card">
          <el-form>
            <div class="SH_card-title">
              <span style="font-size: 14px">备注</span>
            </div>
            <div class="SH_card-body">
              <el-divider />
              <div v-if="registrationInfoEditDisable" style="text-align: left">
                {{ registration_info_item.description }}
              </div>
              <el-input
                type="textarea"
                v-else
                v-model="registration_info_item.description"
              />
            </div>
          </el-form>
        </div>
        <el-alert type="info">
          <div style="text-align: left">
            <p>
              1.缴费后报名会有短信发送提醒，如若未收到短信或有其它报名疑问请联系（张老师:18028702991）
            </p>
            <p>2.本次年会因疫情原因，举办方不支持现场缴费。</p>
            <p>3.请完整填写发票信息内容，方便后续开票处理</p>
            <p>4.普通参会者邀请函下载</p>
            <p>5.会议议程下载（2020.11.26日更新）</p>
          </div>
        </el-alert>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      title="审核详情"
      :visible.sync="reviewDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>
        <p>审核结果：未通过</p>
        <p>审核日期：2020-07-15</p>
        <p style="text-align: left">
          您的报名表中选择了代订机票，但是没有填写清楚目的地，请写清楚国家、省、市。
          请修改后重新提交或者电话和我们的工作人员联系。
        </p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRegistration } from '@/apis/registration.js';
import { putRegistration } from '@/apis/registration.js';
import { getSubForum } from '@/apis/subForumInfo.js';
import { getEnum } from '@/apis/enum.js';
import { postRetinue } from '@/apis/registration.js';
import { getRegistration } from '@/apis/registration';
import { getEventDetail } from '@/apis/eventDetail';
import UploadImage from './UploadImage.vue';
export default {
  name: 'RegistrationFormContent',
  props: {
    eventId: Number,
    blRegBtn: Boolean,
    submitTimer: Number,
  },
  components: { UploadImage },
  mounted() {
    console.log('level', this.$store.state.scholar_level);
    let forum_id = this.$route.query.eventId;
    // this.forumId = Number(forum_id);
    console.log('加载', forum_id);
    getEventDetail(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            //  console.log(res.data);
            this.hotels = res.data?.data?.item.setting_json.hotel_list?.filter(
              (item) => !item.disabled,
            );
            this.has_sub_forum = res?.data?.data?.item?.has_sub_forum;
            this.registerTypes =
              res.data?.data?.item.setting_json.level_fee_info;
            this.extraFields =
              res.data?.data?.item.setting_json.extra_registration_json;
            if (!this.registration_info_item.extraInfo)
              this.$set(this.registration_info_item, 'extraInfo', {});
            this.extraFields?.forEach((field) => {
              if (!this.registration_info_item.extraInfo[field.key])
                this.$set(this.registration_info_item.extraInfo, field.key, {
                  value: undefined,
                });
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // 根据获取的数据执行对报名表单赋值操作
    getRegistration({ forum_id: forum_id })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);
            if (
              res.data.data?.registration_info?.[0].registration_level === 1 ||
              this.scholar_level === 1
            ) {
              this.level = 1;
            } else {
              this.level = 0;
            }
            if (res.data.data.registration_status === 1) {
              this.$store.commit(
                'AddCurrentRegistration',
                res.data.data.registration_info[0],
              );
              this.$store.commit('AddCurrentRegistrationState', 1);
              // 如果获取到的报名状态为1，设定报名状态为1
              this.registrationInfoEditDisable = true;
              this.contactPersonEditDisable = true;
              this.hotelInfoEditDisable = true;
              this.travelInfoEditDisable = true;
              // 从store获取的SetRegistration_info_item
              // 使用$set 赋给表单model绑定的字段registration_info_item
              // 解决表单被赋值后不可编辑的问题
              console.log('获取报名表', this.SetRegistration_info_item);
              this.SetRegistration_info_item.formRegistrationInfo = JSON.parse(
                this.SetRegistration_info_item.basic_json,
              );
              this.SetRegistration_info_item.formContactPerson = JSON.parse(
                this.SetRegistration_info_item.contact_person_json,
              );
              this.SetRegistration_info_item.formRetinueInfo = JSON.parse(
                this.SetRegistration_info_item.retinue_json,
              );

              this.SetRegistration_info_item.formHotelInfo = JSON.parse(
                this.SetRegistration_info_item.hotel_json,
              );
              this.SetRegistration_info_item.formTravelInfo = JSON.parse(
                this.SetRegistration_info_item.travel_json,
              );
              this.SetRegistration_info_item.formReceptionInfo = JSON.parse(
                this.SetRegistration_info_item.reception_json,
              );
              this.SetRegistration_info_item.paymentInfo = JSON.parse(
                this.SetRegistration_info_item.payment_json,
              );
              this.SetRegistration_info_item.invoiceInfo = JSON.parse(
                this.SetRegistration_info_item.invoice_json,
              );
              this.SetRegistration_info_item.extraInfo = JSON.parse(
                this.SetRegistration_info_item.extra_registration_json,
              );
              // 使用$set 给表单赋值
              // 非json字符串字段显示
              this.$set(
                this.registration_info_item,
                'has_contact_person',
                this.SetRegistration_info_item.has_contact_person,
              );
              this.$set(
                this.registration_info_item,
                'has_retinue',
                this.SetRegistration_info_item.has_retinue,
              );
              this.$set(
                this.registration_info_item,
                'need_hotel',
                this.SetRegistration_info_item.need_hotel,
              );
              this.$set(
                this.registration_info_item,
                'need_travel',
                this.SetRegistration_info_item.need_travel,
              );
              this.$set(
                this.registration_info_item,
                'need_reception',
                this.SetRegistration_info_item.need_reception,
              );
              this.$set(
                this.registration_info_item,
                'paymentInfo',
                this.SetRegistration_info_item.paymentInfo,
              );
              this.$set(
                this.registration_info_item,
                'registration_level',
                this.SetRegistration_info_item.registration_level,
              );
              this.$set(
                this.registration_info_item,
                'invoiceInfo',
                this.SetRegistration_info_item.invoiceInfo,
              );
              this.$set(
                this.registration_info_item,
                'extraInfo',
                this.SetRegistration_info_item.extraInfo,
              );
              this.$set(
                this.registration_info_item,
                'description',
                this.SetRegistration_info_item.description,
              );
              // 报名者姓名字段数据处理
              if (
                this.SetRegistration_info_item.sub_forum_id !== null &&
                this.SetRegistration_info_item.sub_forum_id !== undefined &&
                this.SetRegistration_info_item.sub_forum_id !== ''
              ) {
                this.$set(
                  this.registration_info_item,
                  'sub_forum_id',
                  this.SetRegistration_info_item.sub_forum_id,
                );
              } else {
                this.$set(this.registration_info_item, 'sub_forum_id', null);
              }
              // 报名者姓名字段数据处理
              if (
                this.SetRegistration_info_item.name !== null &&
                this.SetRegistration_info_item.name !== undefined &&
                this.SetRegistration_info_item.name !== ''
              ) {
                this.$set(
                  this.registration_info_item,
                  'name',
                  this.SetRegistration_info_item.name,
                );
              } else {
                this.$set(this.registration_info_item, 'name', '');
              }
              // 报名者单位字段数据处理
              if (
                this.SetRegistration_info_item.organization !== null &&
                this.SetRegistration_info_item.organization !== undefined &&
                this.SetRegistration_info_item.organization !== ''
              ) {
                this.$set(
                  this.registration_info_item,
                  'organization',
                  this.SetRegistration_info_item.organization,
                );
              } else {
                this.$set(this.registration_info_item, 'organization', '');
              }
              // 报名基本信息数据处理
              if (
                this.SetRegistration_info_item.formRegistrationInfo !== null &&
                this.SetRegistration_info_item.formRegistrationInfo !==
                  undefined &&
                this.SetRegistration_info_item.formRegistrationInfo !== '' &&
                this.SetRegistration_info_item.formRegistrationInfo !== {}
              ) {
                this.$set(
                  this.registration_info_item,
                  'formRegistrationInfo',
                  this.SetRegistration_info_item.formRegistrationInfo,
                );
              }
              // 联系人数据处理
              if (
                this.SetRegistration_info_item.has_contact_person === true &&
                this.SetRegistration_info_item.formContactPerson !== null &&
                this.SetRegistration_info_item.formContactPerson !==
                  undefined &&
                this.SetRegistration_info_item.formContactPerson !== '' &&
                this.SetRegistration_info_item.formContactPerson !== {}
              ) {
                this.$set(
                  this.registration_info_item,
                  'formContactPerson',
                  this.SetRegistration_info_item.formContactPerson,
                );
              }
              // 随行人员数据处理
              if (
                this.SetRegistration_info_item.has_retinue === true &&
                this.SetRegistration_info_item.formRetinueInfo !== null &&
                this.SetRegistration_info_item.formRetinueInfo !== undefined &&
                this.SetRegistration_info_item.formRetinueInfo !== '' &&
                this.SetRegistration_info_item.formRetinueInfo !== []
              ) {
                this.$set(
                  this.registration_info_item.formRetinueInfo,
                  'tableData',
                  this.SetRegistration_info_item.formRetinueInfo,
                );
              }
              // 预定酒店数据处理
              this.$set(
                this.registration_info_item,
                'formHotelInfo',
                this.SetRegistration_info_item.formHotelInfo,
              );
              // 交通信息数据处理
              if (
                this.SetRegistration_info_item.need_travel === true &&
                this.SetRegistration_info_item.formTravelInfo !== null &&
                this.SetRegistration_info_item.formTravelInfo !== undefined &&
                this.SetRegistration_info_item.formTravelInfo !== '' &&
                this.SetRegistration_info_item.formTravelInfo !== {}
              ) {
                this.$set(
                  this.registration_info_item,
                  'formTravelInfo',
                  this.SetRegistration_info_item.formTravelInfo,
                );
              }
              // 接待信息数据处理
              if (
                this.SetRegistration_info_item.need_reception === true &&
                this.SetRegistration_info_item.formReceptionInfo !== null &&
                this.SetRegistration_info_item.formReceptionInfo !==
                  undefined &&
                this.SetRegistration_info_item.formReceptionInfo !== '' &&
                this.SetRegistration_info_item.formReceptionInfo !== {}
              ) {
                this.$set(
                  this.registration_info_item,
                  'formReceptionInfo',
                  this.SetRegistration_info_item.formReceptionInfo,
                );
              }
            } else {
              this.$store.commit('AddCurrentRegistrationState', 0);
              this.registrationInfoEditDisable = false;
              this.contactPersonEditDisable = false;
              this.retinueEditDisable = false;
              this.hotelInfoEditDisable = false;
              this.travelInfoEditDisable = false;
              const { currentUserInfo } = this.$store.state.toGetCurrentUser;
              this.registration_info_item.name = currentUserInfo.name;
              this.registration_info_item.formRegistrationInfo.gender =
                currentUserInfo.gender;
              this.registration_info_item.organization =
                currentUserInfo.institution || currentUserInfo.institution_en;
              this.registration_info_item.formRegistrationInfo.duty =
                currentUserInfo.duty;
              this.registration_info_item.formRegistrationInfo.job_title =
                currentUserInfo.job_title;
              this.registration_info_item.formRegistrationInfo.country =
                currentUserInfo.country;
              this.registration_info_item.formRegistrationInfo.city =
                currentUserInfo.city;
              this.registration_info_item.formRegistrationInfo.postcode =
                currentUserInfo.postcode;
              this.registration_info_item.formRegistrationInfo.address =
                currentUserInfo.address;
              this.registration_info_item.formRegistrationInfo.cell_phone =
                currentUserInfo.cellphone;
              this.registration_info_item.formRegistrationInfo.email =
                currentUserInfo.email;
              this.registration_info_item.formRegistrationInfo.phone =
                currentUserInfo.phone;
              this.registration_info_item.formRegistrationInfo.fax =
                currentUserInfo.fax;
              this.registration_info_item.formRegistrationInfo.certificate_type =
                currentUserInfo.certificate_type;
              this.registration_info_item.formRegistrationInfo.certificate_number =
                currentUserInfo.certificate_number;
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('报名表未获取成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // 获取分会议列表
    getSubForum(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log('XXXXXXXXXXXXX');
            // console.log(res.data);
            this.subEvents = res.data.data.items;
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('分会议列表未获取成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // 获取证件类型
    getEnum()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.certificate_type_list =
              res.data.data.enum_info.certificate_type;
            this.gender_type_list = res.data.data.enum_info.gender_type;
            console.log(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          this.$message.error('证件类型未获取成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      level: 0,
      // forumId: null,
      // 报名审核详情弹窗
      reviewDialogVisible: false,
      // 报名状态,由myEventDesc请求报名表接口，commit到store，这里由computed获取
      // registration_status: null,

      // 报名表成功后返回的data
      registrationRes: {},

      // 身份证字典
      certificate_type_list: {},
      gender_type_list: {},
      subEvents: [],

      has_sub_forum: false,

      //报名表是否可编辑状态按钮显示
      registrationInfoEditDisable: true,
      contactPersonEditDisable: true,
      retinueEditDisable: true,
      hotelInfoEditDisable: true,
      travelInfoEditDisable: true,

      // 随行人员弹窗
      retinueInputForm: {
        certificate_type: 0,
      },

      // 随行人员规则
      formRetinueRule: {},
      editIndex: null,
      retinueEditState: false,
      retinueDialogVisible: false,
      retinueFormRules: {
        last_name_zh: [
          { required: true, message: '请输入中文姓', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        first_name_zh: [
          { required: true, message: '请输入中文名', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        first_name_en: [
          { required: true, message: '请输入英文名', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        last_name_en: [
          { required: true, message: '请输入英文姓', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
      },

      // 交通工具选择器
      travel_type_list: [
        {
          name: '飞机',
          value: 0,
        },
        {
          name: '高铁',
          value: 1,
        },
      ],

      // 报名表获取信息
      // SetRegistration_info_item:{
      //     basic_json:'{}',
      //     formRegistrationInfo:{},
      //     contact_person_json:'{}',
      //     formContactPerson:{},
      //     hotel_json:'{}',
      //     formHotelInfo:{},
      //     travel_json: '{}',
      //     formTravelInfo:{},
      //     reception_json: '{}',
      //     formReceptionInfo:{},
      // },
      //报名表全部信息
      registration_info_item: {
        sub_forum_id: null,
        name: '',
        organization: '',
        registration_level: null,
        // 报名信息表单
        basic_json: {},
        formRegistrationInfo: {
          gender: 0,
          duty: '',
          job_title: '',
          country: '',
          city: '',
          postcode: '',
          address: '',
          cell_phone: '',
          email: '',
          phone: '',
          fax: '',
          certificate_type: 0,
          certificate_number: '',
        },
        // 联系人表单
        has_contact_person: false,
        contact_person_json: {},
        formContactPerson: {
          name: '',
          gender: 0,
          duty: '',
          job_title: '',
          country: '',
          city: '',
          postcode: '',
          address: '',
          cell_phone: '',
          email: '',
          phone: '',
          fax: '',
          certificate_type: 0,
          certificate_number: '',
        },
        // 是否有随行人员
        has_retinue: false,
        // 随行人员表格
        retinue_json: [],
        formRetinueInfo: {
          tableData: [],
        },

        // 住宿信息表单
        need_hotel: false,
        hotel_json: {},
        formHotelInfo: {
          hotel_name: '', // 酒店名称
          hotel_room_type: '',
          number_of_room: 0,
        },
        //交通信息表单
        need_travel: false,
        travel_json: {},
        formTravelInfo: {
          travel_type: 0,
          from_city: '',
          arr_city: '',
          arrival_time: '', // 抵达时间
          departure_time: '', // 离开时间
          arr_flight_no: '', // 抵达航班/动车号
          de_flight_no: '', // 离开航班/动车号
          // de_city: '',
          // to_city: '',
          need_ticket: false,
          sk_from_city: '',
          sk_arr_city: '',
          sk_de_city: '',
          sk_to_city: '',
          sk_arrival_time: '', // 计划抵达时间
          sk_departure_time: '', // 计划离开时间
          need_reception: false,
        },
        // 接待信息表单（前端用户不编辑，管理端编辑填写信息，在前端报名表中显示）
        need_reception: false,
        reception_json: {},
        formReceptionInfo: {
          name: '', // 姓名
          organization: '', // 单位 （拼写有错我改过来了，看看是不是数据库字段也错了）
          cell_phone: '', // 手机 （改成了cell_phone，电话改成了手机）
          email: '', // 邮箱
        },
        paymentInfo: {
          payment_result_screenshot: '',
        },
        invoiceInfo: {
          name: '',
          code: '',
          address: '',
          phone: '',
          bank: '',
          account: '',
          mail_address: '',
          email: '',
          comment: '',
        },
        extraInfo: {},
      },

      // 报名信息规则
      formRegistrationRule: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        organization: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        'formRegistrationInfo.cell_phone': [
          { validator: this.checkCellPhone, trigger: 'blur' },
        ],
        'formRegistrationInfo.email': [
          { required: true, message: '请输入电子邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        'formRegistrationInfo.certificate_type': [
          { required: true, message: '请选择证件类型' },
        ],
        'formRegistrationInfo.certificate_number': [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个数字或英文字符',
            trigger: 'blur',
          },
        ],
        'formRegistrationInfo.phone': [
          { validator: this.checkPhone, trigger: 'blur' },
        ],
        'formRegistrationInfo.fax': [
          { validator: this.checkPhone, trigger: 'blur' },
        ],
      },

      // 联系人员规则
      formContactPersonRule: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        cell_phone: [{ validator: this.checkCellPhone, trigger: 'blur' }],
        email: [
          { required: true, message: '请输入电子邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
        ],
        certificate_type: [{ required: true, message: '请选择证件类型' }],
        certificate_number: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个数字或英文字符',
            trigger: 'blur',
          },
        ],
        phone: [{ validator: this.checkPhone, trigger: 'blur' }],
        fax: [{ validator: this.checkPhone, trigger: 'blur' }],
      },

      // 酒店日期选择器
      hotelPickerOptions0: {
        disabledDate: (date) => {
          if (date.getTime() < Date.now() - 1000 * 60 * 60 * 24) return true;
          if (this.registration_info_item.formHotelInfo.check_out_time) {
            return (
              date.getTime() >
              this.registration_info_item.formHotelInfo.check_out_time.getTime()
            );
          }
        },
      },
      hotelPickerOptions1: {
        disabledDate: (date) => {
          if (date.getTime() < Date.now() - 1000 * 60 * 60 * 24) return true;
          if (this.registration_info_item.formHotelInfo.check_in_time) {
            return (
              date.getTime() <
              this.registration_info_item.formHotelInfo.check_in_time.getTime()
            );
          }
        },
      },

      // 抵达日期选择器时间范围限制
      travelPickerOptions0: {
        disabledDate: (date) => {
          if (date.getTime() < Date.now() - 1000 * 60 * 60 * 24) return true;
        },
      },

      // 离开日期选择器时间范围限制
      travelPickerOptions1: {
        disabledDate: (date) => {
          if (
            this.registration_info_item.formTravelInfo.arrival_time !== '' &&
            this.registration_info_item.formTravelInfo.arrival_time !== null
          ) {
            let currentDate = this.registration_info_item.formTravelInfo
              .arrival_time;
            let threeMonths = currentDate.setMonth(currentDate.getMonth() + 1);
            currentDate.setMonth(currentDate.getMonth() - 1);
            return (
              date.getTime() <
                this.registration_info_item.formTravelInfo.arrival_time ||
              date.getTime() > threeMonths
            );
          } else {
            return date.getTime() < Date.now();
          }
        },
      },
      // 计划抵达日期选择器时间范围限制
      skePickerOptions0: {
        disabledDate: (date) => {
          if (
            this.registration_info_item.formTravelInfo.sk_departure_time !==
              '' &&
            this.registration_info_item.formTravelInfo.sk_departure_time !==
              null
          ) {
            let skeCurrentDate = this.registration_info_item.formTravelInfo
              .sk_departure_time;
            let threeMonths = skeCurrentDate.setMonth(
              skeCurrentDate.getMonth() - 1,
            );
            skeCurrentDate.setMonth(skeCurrentDate.getMonth() + 1);
            return (
              date.getTime() >
                this.registration_info_item.formTravelInfo.sk_departure_time ||
              date.getTime() < threeMonths
            );
          } else {
            return date.getTime() < Date.now();
          }
        },
      },
      // 计划离开日期选择器时间范围限制
      skePickerOptions1: {
        disabledDate: (date) => {
          if (
            this.registration_info_item.formTravelInfo.sk_arrival_time !== '' &&
            this.registration_info_item.formTravelInfo.sk_arrival_time !== null
          ) {
            let skeCurrentDate = this.registration_info_item.formTravelInfo
              .sk_arrival_time;
            let threeMonths = skeCurrentDate.setMonth(
              skeCurrentDate.getMonth() + 1,
            );
            skeCurrentDate.setMonth(skeCurrentDate.getMonth() - 1);
            return (
              date.getTime() <
                this.registration_info_item.formTravelInfo.sk_arrival_time ||
              date.getTime() > threeMonths
            );
          } else {
            return date.getTime() < Date.now();
          }
        },
      },

      formLabelWidth: '108px',
      hotels: [],
      registerTypes: [],
      extraFields: [],
    };
  },
  methods: {
    // 添加随行人员
    // 打开作者表单对话框
    handleRetinueDialogOpen() {
      this.retinueDialogVisible = true;
    },
    // 关闭随行人员表单对话框
    handleRetinueDialogClose() {
      this.retinueDialogVisible = false;
    },
    // 表格上方 添加随行人员按钮
    openAddRetinueForm() {
      this.handleRetinueDialogOpen();
      this.retinueInputForm = {};
      this.retinueEditState = false;
    },
    // 行右侧 编辑文字按钮
    editRetinueRow(index, row) {
      this.handleRetinueDialogOpen();
      this.retinueEditState = true;
      this.editIndex = index;
      this.retinueInputForm = JSON.parse(JSON.stringify(row));
    },
    // 弹窗底部 （取消-按钮 关闭作者表单对话框）
    cancelRetinueForm() {
      this.handleRetinueDialogClose();
    },
    // 随行人员弹窗底部（保存修改-按钮）
    saveRetinueRow(retinueInputForm) {
      this.$refs[retinueInputForm].validate((valid) => {
        if (valid) {
          let j = this.retinueInputForm;
          this.$set(
            this.registration_info_item.formRetinueInfo.tableData,
            this.editIndex,
            j,
          );
          this.handleRetinueDialogClose();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 随行人员弹窗底部（添加随行人员-按钮）
    addRetinueRow(retinueInputForm) {
      // 将弹窗里的随行人员数据push到tableData里。
      this.$refs[retinueInputForm].validate((valid) => {
        if (valid) {
          let j = this.retinueInputForm;
          this.registration_info_item.formRetinueInfo.tableData.push(j);
          this.handleRetinueDialogClose();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    //上移随行人员行数据
    upLayer(index) {
      if (index === 0) {
        this.$message({
          message: '处于顶端，不能继续上移',
          type: 'warning',
        });
      } else {
        const that = this;
        const upData =
          that.registration_info_item.formRetinueInfo.tableData[index - 1];
        that.registration_info_item.formRetinueInfo.tableData.splice(
          index - 1,
          1,
        );
        that.registration_info_item.formRetinueInfo.tableData.splice(
          index,
          0,
          upData,
        );
      }
    },
    //下移随行人员行数据
    downLayer(index) {
      const that = this;
      if (
        index + 1 ===
        that.registration_info_item.formRetinueInfo.tableData.length
      ) {
        this.$message({
          message: '处于最底端，不能继续下移',
          type: 'warning',
        });
      } else {
        const downData =
          that.registration_info_item.formRetinueInfo.tableData[index + 1];
        that.registration_info_item.formRetinueInfo.tableData.splice(
          index + 1,
          1,
        );
        that.registration_info_item.formRetinueInfo.tableData.splice(
          index,
          0,
          downData,
        );
      }
    },
    // 删除随行人员行
    deleteRetinueRow(index, rows) {
      rows.splice(index, 1);
    },

    /*
            // 测试提交数据
            handleSubmit(){
                this.$refs['registration_info_item'].validate((valid) => {
                        if (valid) {
                            console.log(
                                '基本信息', this.registration_info_item.formRegistrationInfo,
                                '联系人信息', this.registration_info_item.formContactPerson,
                                '住宿信息', this.registration_info_item.formHotelInfo,
                                '交通信息', this.registration_info_item.formTravelInfo,
                            )
                        }
                })

            },

             */

    handleSubmit(isEdit) {
      this.$refs['registration_info_item'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要提交表单吗？')
            .then(() => {
              this.registration_info_item.basic_json = this.registration_info_item.formRegistrationInfo;
              // if (this.registration_info_item.has_contact_person === true) {
              //   this.registration_info_item.contact_person_json = this.registration_info_item.formContactPerson;
              // } else {
              //   this.registration_info_item.contact_person_json = {};
              // }
              // if (this.registration_info_item.has_retinue === true) {
              //   this.registration_info_item.retinue_json = this.registration_info_item.formRetinueInfo.tableData;
              // } else {
              //   this.registration_info_item.retinue_json = [];
              // }
              // if (this.registration_info_item.need_hotel === true) {
              this.registration_info_item.hotel_json = this.registration_info_item.formHotelInfo;
              // } else {
              //   this.registration_info_item.hotel_json = {};
              // }
              // if (this.registration_info_item.need_travel === true) {
              //   this.registration_info_item.travel_json = this.registration_info_item.formTravelInfo;
              // } else {
              //   this.registration_info_item.travel_json = {};
              // }
              let registration_id = this.SetRegistration_info_item
                .registration_id;
              const data = {
                forum_id: this.eventId,
                sub_forum_id: this.registration_info_item.sub_forum_id,
                name: this.registration_info_item.name,
                description: this.registration_info_item.description,
                organization: this.registration_info_item.organization,
                basic_json: this.registration_info_item.basic_json,
                has_contact_person: this.registration_info_item
                  .has_contact_person,
                contact_person_json: this.registration_info_item
                  .contact_person_json,
                has_retinue: this.registration_info_item.has_retinue,
                retinue_json: this.registration_info_item.retinue_json,
                need_hotel: this.registration_info_item.need_hotel,
                hotel_json: this.registration_info_item.hotel_json,
                need_travel: this.registration_info_item.need_travel,
                travel_json: this.registration_info_item.travel_json,
                extra_registration_json: this.registration_info_item.extraInfo,
                invoice_json: this.registration_info_item.invoiceInfo,
                payment_json: this.registration_info_item.paymentInfo,
              };
              if (registration_id)
                putRegistration(registration_id, data).then((res) => {
                  this.timer = setTimeout(() => {
                    if (res.status === 200) {
                      if (res.data.success === true) {
                        this.$alert('报名信息' + res.data.message, {
                          confirmButtonText: '确定',
                        });
                        this.registrationInfoEditDisable = true;
                      } else {
                        console.log(res.data);
                        this.$message.error(res.data.message);
                      }
                    } else {
                      console.log(res.data);
                      this.$alert('未能修改报名信息，' + res.data.message, {
                        confirmButtonText: '确定',
                      });
                    }
                  }, 200);
                });
              else
                postRegistration(data)
                  .then((res) => {
                    this.$emit('loading', true);
                    this.timer = setTimeout(() => {
                      // 动画关闭需要一定的时间
                      if (res.status === 200) {
                        if (res.data.success === true) {
                          this.registrationRes = res.data.data;
                          console.log(this.registrationRes);
                          this.$emit('parentBlRegBtn', true);
                          if (this.has_retinue === true) {
                            this.submitRetinueInfo();
                          }
                          this.$emit('loading', false);
                          this.$alert('报名表提交' + res.data.message, {
                            confirmButtonText: '确定',
                          }).then(() => {
                            this.$router.push({
                              path: '/myRegistrationForm',
                              query: { eventId: this.eventId },
                            });
                          });
                        } else {
                          console.log(res.data.message);
                          this.$message.error(res.data.message);
                        }
                      } else {
                        this.$message.error('未请求成功');
                        this.$emit('loading', false);
                        console.log('错误');
                      }
                    }, 2000);
                  })
                  .catch(() => {
                    this.$message.error('未请求成功');
                  });
            })
            .catch(() => {});
        }
      });
    },

    submitRetinueInfo() {
      postRetinue({
        registration_id: this.registrationRes.registration_id,
        retinue_list: this.formRetinueInfo.tableData,
      }).then((req) => {
        if (req.status === 200) {
          if (req.data.success === true) {
            console.log(req.data);
          } else {
            console.log(req.data);
            this.$message.error(
              req.data.message + '请到用户中心我的会议查看报名表，并补充信息',
            );
          }
        } else {
          console.log(
            '随行人员提交失败，请到用户中心我的会议查看报名表，并补充信息',
          );
          this.$message.error(
            '随行人员提交失败，请到用户中心我的会议查看报名表，并补充信息',
          );
        }
      });
    },

    // 折叠面板开关
    handleChange() {},
    // 弹框关闭
    handleClose() {
      this.reviewDialogVisible = false;
    },
    check_num() {
      if (this.registration_info_item.formRegistrationInfo.certificate_number) {
        this.registration_info_item.formRegistrationInfo.certificate_number = this.registration_info_item.formRegistrationInfo.certificate_number.replace(
          /[^a-zA-Z0-9]/g,
          '',
        );
      }
    },
    checkCellPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    },
    checkPhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        const reg = /^(\d{3,4}-)?\d{7,8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的座机号'));
        }
      }
    },

    // 编辑报名表基本信息开启
    editRegistrationInfo() {
      this.registrationInfoEditDisable = false;
    },
    // 保存编辑的报名表基本信息
    saveRegistrationInfo() {
      this.$refs['registration_info_item'].validate((valid) => {
        if (valid) {
          let registration_id = this.SetRegistration_info_item.registration_id;
          let basicJson = JSON.stringify(
            this.registration_info_item.formRegistrationInfo,
          );
          putRegistration(registration_id, {
            registration_id: registration_id,
            sub_forum_id: this.registration_info_item.sub_forum_id,
            name: this.registration_info_item.name,
            organization: this.registration_info_item.organization,
            basic_json: basicJson,
          }).then((res) => {
            this.timer = setTimeout(() => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  this.$alert('报名信息' + res.data.message, {
                    confirmButtonText: '确定',
                  });
                  this.registrationInfoEditDisable = true;
                } else {
                  console.log(res.data);
                  this.$message.error(res.data.message);
                }
              } else {
                console.log(res.data);
                this.$alert('未能修改报名信息，' + res.data.message, {
                  confirmButtonText: '确定',
                });
              }
            }, 200);
          });
        }
      });
    },

    // 编辑联系人信息开启
    editContactPerson() {
      this.contactPersonEditDisable = false;
      this.registration_info_item.has_contact_person = true;
    },
    // 保存编辑的联系人信息
    saveContactPerson() {
      this.$refs['formContactPerson'].validate((valid) => {
        if (valid) {
          let registration_id = this.SetRegistration_info_item.registration_id;
          if (this.registration_info_item.has_contact_person === true) {
            this.registration_info_item.contact_person_json = JSON.stringify(
              this.registration_info_item.formContactPerson,
            );
          } else {
            this.registration_info_item.contact_person_json = '{}';
          }
          putRegistration(registration_id, {
            registration_id: registration_id,
            has_contact_person: this.registration_info_item.has_contact_person,
            contact_person_json: this.registration_info_item
              .contact_person_json,
          }).then((res) => {
            this.timer = setTimeout(() => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  this.$alert('联系人信息' + res.data.message, {
                    confirmButtonText: '确定',
                  });
                  this.contactPersonEditDisable = true;
                } else {
                  console.log(res.data);
                  this.$message.error(res.data.message);
                }
              } else {
                console.log(res.data);
                this.$alert('未能修改报名信息，' + res.data.message, {
                  confirmButtonText: '确定',
                });
              }
            }, 200);
          });
        }
      });
    },

    // 编辑随行人员开启
    editRetinue() {
      this.retinueEditDisable = false;
      this.registration_info_item.has_retinue = true;
    },
    // 保存编辑的随行人员信息
    saveRetinue() {
      let registration_id = this.SetRegistration_info_item.registration_id;
      if (this.registration_info_item.has_retinue === true) {
        this.registration_info_item.retinue_json = JSON.stringify(
          this.registration_info_item.formRetinueInfo.tableData,
        );
      } else {
        this.registration_info_item.retinue_json = '[]';
      }
      putRegistration(registration_id, {
        registration_id: registration_id,
        has_retinue: this.registration_info_item.has_retinue,
        retinue_json: this.registration_info_item.retinue_json,
      }).then((res) => {
        this.timer = setTimeout(() => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.$alert('随行人员' + res.data.message, {
                confirmButtonText: '确定',
              });
              this.hotelInfoEditDisable = true;
            } else {
              console.log(res.data);
              this.$message.error(res.data.message);
            }
          } else {
            console.log(res.data);
            this.$alert('未能修改随行人员，' + res.data.message, {
              confirmButtonText: '确定',
            });
          }
        }, 200);
      });
    },

    // 编辑住宿信息开启
    editHotelInfo() {
      this.hotelInfoEditDisable = false;
      this.registration_info_item.need_hotel = true;
    },
    // 保存编辑的住宿信息
    saveHotelInfo() {
      let registration_id = this.SetRegistration_info_item.registration_id;
      if (this.registration_info_item.need_hotel === true) {
        this.registration_info_item.hotel_json = JSON.stringify(
          this.registration_info_item.formHotelInfo,
        );
      } else {
        this.registration_info_item.hotel_json = '{}';
      }
      putRegistration(registration_id, {
        registration_id: registration_id,
        need_hotel: this.registration_info_item.need_hotel,
        hotel_json: this.registration_info_item.hotel_json,
      }).then((res) => {
        this.timer = setTimeout(() => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.$alert('住宿信息' + res.data.message, {
                confirmButtonText: '确定',
              });
              this.hotelInfoEditDisable = true;
            } else {
              console.log(res.data);
              this.$message.error(res.data.message);
            }
          } else {
            console.log(res.data);
            this.$alert('未能修改住宿信息，' + res.data.message, {
              confirmButtonText: '确定',
            });
          }
        }, 200);
      });
    },

    // 编辑交通信息开启
    editTravelInfo() {
      this.travelInfoEditDisable = false;
      this.registration_info_item.need_travel = true;
    },
    // 保存编辑的交通信息
    saveTravelInfo() {
      let registration_id = this.SetRegistration_info_item.registration_id;
      if (this.registration_info_item.need_travel === true) {
        this.registration_info_item.travel_json = JSON.stringify(
          this.registration_info_item.formTravelInfo,
        );
      } else {
        this.registration_info_item.travel_json = '{}';
      }
      putRegistration(registration_id, {
        registration_id: registration_id,
        need_travel: this.registration_info_item.need_travel,
        travel_json: this.registration_info_item.travel_json,
      }).then((res) => {
        this.timer = setTimeout(() => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.$alert('交通信息' + res.data.message, {
                confirmButtonText: '确定',
              });
              this.travelInfoEditDisable = true;
            } else {
              console.log(res.data);
              this.$message.error(res.data.message);
            }
          } else {
            console.log(res.data);
            this.$alert('未能修改交通信息，' + res.data.message, {
              confirmButtonText: '确定',
            });
          }
        }, 200);
      });
    },

    // 当交通工具选择不是飞机时，代订机票的选项置为false
    travelTypeChange() {
      if (this.registration_info_item.formTravelInfo.travel_type !== 0) {
        this.registration_info_item.formTravelInfo.need_ticket = false;
      }
    },

    toJson(str) {
      let jsonToObj = JSON.parse(str);
      // console.log(jsonToObj);
      return jsonToObj;
    },
    handleAvatarSuccess(response) {
      this.registration_info_item.paymentInfo.payment_result_screenshot = response;
    },
  },

  computed: {
    timer: {
      get() {
        return this.submitTimer;
      },
      set(val) {
        this.$emit('newtimer', val);
      },
    },
    registration_status: {
      get() {
        return this.$store.state.toGetCurrentRegistration.registration_status;
      },
    },
    SetRegistration_info_item: {
      get() {
        return this.$store.state.toGetCurrentRegistration
          .SetRegistration_info_item;
      },
    },
    scholar_level: {
      get() {
        return this.$store.state.toGetCurrentUser.scholar_level;
      },
    },
    currentRegisterType() {
      return (
        this.registerTypes.find(
          (item) => item.key === this.registration_info_item.registration_level,
        ) || {}
      );
    },
    currentHotel() {
      return (
        this.hotels.find(
          (item) =>
            item.hotel_name ===
            this.registration_info_item.formHotelInfo.hotel_name,
        ) || {}
      );
    },
  },
};
</script>

<style scoped></style>
